import React from 'react';
import './PendingInvites.css';

const PendingInvites = ({ invites, onAccept, onDecline, loading }) => {
  if (loading || invites.length === 0) {
    return null;
  }

  return (
    <div className="pending-invites-banner">
      <div className="pending-invites-content">
        <div className="pending-invites-header">
          <span className="pending-invites-icon">📨</span>
          <h3>Pending Project Invitations ({invites.length})</h3>
        </div>

        <div className="pending-invites-list">
          {invites.map(invite => (
            <div key={invite.id} className="pending-invite-item">
              <div className="invite-info">
                <div className="invite-project-name">{invite.projectName}</div>
                <div className="invite-details">
                  <strong>{invite.inviterName}</strong> invited you to collaborate
                  {invite.projectDescription && <span> • {invite.projectDescription}</span>}
                </div>
                <div className="invite-expires">
                  Expires {new Date(invite.expiresAt).toLocaleDateString()}
                </div>
              </div>
              <div className="invite-actions">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => onAccept(invite.token)}
                >
                  Accept
                </button>
                <button
                  className="btn btn-outline btn-sm"
                  onClick={() => onDecline(invite.token)}
                >
                  Decline
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PendingInvites;
